import { Content } from '@volkswagen-onehub/fa-content-service';
import { useFeatureServices } from 'src/feature-app';
import { DealersData, MatchSelectedOptions, Offer } from 'src/types';

export type EmbeddedFeatureApp =
  | 'es-ofertas'
  | 'es-stock-teaser'
  | 'es-match'
  | 'es-calculadora'
  | 'es-maintenance'
  | 'es-bono'
  | 'es-mis_beneficios'
  | 'Configure';

export interface VehicleCalculadora {
  familyCode: string;
  familyDesc: string;
  modelDescr: string;
  modelKey: string;
  vin: string;
  mileage: number;
  plate: string;
  plateDate: string;
}
interface CalculadoraFields {
  dealer: string; // Código KVPS
  vehicle: VehicleCalculadora[];
  quotePvp: string;
  quoteOperations: {
    id: string; // Identificador único de la operación
    name: string; // Nombre de la operación
    pvp: string; // Precio de la operación
  }[];
  deepLink: string; // URL para acceder a calculadora con el presupuesto precargado
}

type WidgetOptions = 'Mapa';
export interface OneFormContent extends Content, CalculadoraFields {
  'bodycopy-logged'?: string;
  'headline-logged'?: string;
  action?: string;
  argumentatives?: string;
  bodycopy?: string;
  bono?: any;
  carlines?: number[];
  cem?: 'VENTA' | 'POSVENTA';
  cta?: string;
  dpsFields?: {
    field: 'headers[DESC_FORM_DETAIL]' | 'headers[DETALLE_TIPO_PETICION_SIM]';
    value: string;
  }[];
  encuesta?: 'CEM - VENTA' | 'CEM - POSVENTA' | 'CEM - ONESHOP' | 'LEM' | 'NO COMPRA' | 'NO RENOVACIÓN';
  featureApp?: EmbeddedFeatureApp;
  forms?: LeadForm[];
  headline?: string;
  intro?: string;
  isCitaPosventaStageOrDefault?: 'Default' | 'Stage';
  lead_type?: 'test-drive' | 'presupuesto' | 'mas-informacion' | 'cita' | 'stock';
  marketingCodeConfig?: { SalesgroupId: string; SalesgroupName: string };
  match?: Offer; // Hay que implementar el type Preconfiguration
  matchOptions?: MatchSelectedOptions;
  mgm?: 'Bono Cliente' | 'Bono Regalo' | 'Envío Regalo';
  mgmImgSrc?: string;
  mode?: 'Salesgroup' | 'Carline' | 'CarConfiguratorFS' | 'Mixed';
  modo?: 'Dark' | 'Light';
  motivo?: string;
  navidadImgSrc?: string;
  observaciones?: string;
  oferta?: Offer;
  race?: 'true' | 'false';
  salesgroups?: number[];
  stageCitaImgSrc?: string;
  thankYouPage?: string;
  triggerCase?: 'Generico' | 'OneShop';
  userInteraction?: 'false' | 'true';
  widget?: WidgetOptions;
}

export type LeadForm = 'lead-presupuesto' | 'lead-mas_informacion' | 'lead-test_drive' | 'lead-cita' | 'lead-stock';

export function useFaContent(): OneFormContent | undefined {
  return useFeatureServices()['fa-content-service'].content as OneFormContent;
}
